import { Modal } from 'react-bootstrap'
import { COLORS } from 'src/styles/theme'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  #btn {
    text-align: center;
    background: none;
    margin: 0 auto;
    border: none;

    .action-text {
      font-size: 13px;
    }

    .highlight {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`
export const ForgetPasswordModal = styled(Modal)`
  .modal-content {
    color: #404040;
    border: none;
    padding: 16px;

    .modal-title {
      text-align: center;
    }
    .modal-body {
      padding-bottom: 0;
    }
    label {
      padding: 4px 0px;
    }
  }
  .modal-header {
    border: none;
    padding: 0 16px;
  }
`
